var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { SkillCategory } from '@/models/SkillCategory';
let CreateSkillsetDialog = class CreateSkillsetDialog extends Vue {
    constructor() {
        super(...arguments);
        this.name = '';
        this.formValid = false;
        this.nameRules = [(v) => !!v || 'Name is required'];
    }
    mounted() {
        //
    }
    async createSkillSet() {
        try {
            await new SkillCategory().create({ name: this.name });
            this.$emit('onCreated');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    closeDialog() {
        this.$emit('closeDialog');
    }
};
CreateSkillsetDialog = __decorate([
    Component({
        components: {
        //
        },
    })
], CreateSkillsetDialog);
export default CreateSkillsetDialog;
